module.exports = require("core-js-pure/features/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js
// module id = 240
// module chunks = 0 1